export const SOCIAL_SET_LOADING = 'SOCIAL_SET_LOADING';
export const SOCIAL_SET_TOKENS = 'SOCIAL_SET_TOKENS';
export const SOCIAL_SET_ERROR = 'SOCIAL_SET_ERROR';
export const SOCIAL_CONNECT_REQUEST = 'SOCIAL_CONNECT_REQUEST';
export const SOCIAL_ACCOUNTS_FAILURE = 'SOCIAL_ACCOUNTS_FAILURE';
export const SOCIAL_ACCOUNTS_REQUEST = 'SOCIAL_ACCOUNTS_REQUEST';
export const SOCIAL_ACCOUNTS_SUCCESS = 'SOCIAL_ACCOUNTS_SUCCESS';
export const SOCIAL_CONNECT_FAILURE = 'SOCIAL_CONNECT_FAILURE';
export const SOCIAL_CONNECT_PAYLOAD = 'SOCIAL_CONNECT_PAYLOAD';
export const SOCIAL_CONNECT_SUCCESS = 'SOCIAL_CONNECT_SUCCESS';
export const SOCIAL_CONNECT_URL_READY = 'SOCIAL_CONNECT_URL_READY';
export const SOCIAL_DISCONNECT_SUCCESS = 'SOCIAL_DISCONNECT_SUCCESS';
export const SOCIAL_MESSAGE = 'SOCIAL_MESSAGE';
export const SOCIAL_TARGETS_LOADED = 'SOCIAL_TARGETS_LOADED';
export const SOCIAL_TARGET_SELECTED = 'SOCIAL_TARGET_SELECTED';


/** Local (internal) action types used by async actions/social.js etc. */
export const UPSERT_BRAND = "UPSERT_BRAND";
export const SET_BRAND_SETTINGS = "SET_BRAND_SETTINGS";
export const PATCH_BRAND_SETTINGS = "PATCH_BRAND_SETTINGS";

export const UPSERT_SOCIAL_ACCOUNT = "UPSERT_SOCIAL_ACCOUNT";
export const PATCH_SOCIAL_ACCOUNT = "PATCH_SOCIAL_ACCOUNT";
export const REMOVE_SOCIAL_ACCOUNT = "REMOVE_SOCIAL_ACCOUNT";

export const UPSERT_SOCIAL_TARGET = "UPSERT_SOCIAL_TARGET";
export const PATCH_SOCIAL_TARGET = "PATCH_SOCIAL_TARGET";
export const REMOVE_SOCIAL_TARGET = "REMOVE_SOCIAL_TARGET";
export const SET_DEFAULT_SOCIAL_TARGET = "SET_DEFAULT_SOCIAL_TARGET";

export const SET_BRAND_POSTS = "SET_BRAND_POSTS";
export const APPEND_BRAND_POSTS = "APPEND_BRAND_POSTS";
export const SET_BRAND_IDEAS = "SET_BRAND_IDEAS";
export const APPEND_BRAND_IDEAS = "APPEND_BRAND_IDEAS";


export const APPLY_CONNECT_PAYLOAD = 'APPLY_CONNECT_PAYLOAD';
export const SET_BRANDS                  = 'SET_BRANDS';
export const RESET_BRAND_ACTIVE_CONTEXT  = 'RESET_BRAND_ACTIVE_CONTEXT';
